/**
 * One readable sentence from whatever an API call threw.
 *
 * The generated client (`throwOnError: true`) throws the response body,
 * not an `Error`: FastAPI's `{detail: "…"}`, a structured
 * `{detail: {message}}`, or a schema failure's `{detail: [{msg, loc}]}`.
 * A page doing `String(e)` shows "[object Object]".
 */
export function apiErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === "string") return err;
  if (err && typeof err === "object" && "detail" in err) {
    const detail = (err as { detail?: unknown }).detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
      return detail
        .map((d) => (d && typeof d === "object" && "msg" in d ? String((d as { msg: unknown }).msg) : String(d)))
        .join("; ");
    }
    if (detail && typeof detail === "object") {
      const { message, error } = detail as { message?: unknown; error?: unknown };
      if (typeof message === "string") return message;
      if (typeof error === "string") return error;
    }
  }
  return "Request failed";
}
